import { Routes } from '@angular/router';
import { authGuard } from '@portal-core/auth/guards/auth.guard';
import { authUserDataGuard } from '@portal-core/auth/guards/auth-user-data.guard';
import { subdomainGuard } from '@portal-core/auth/guards/subdomain.guard';
import { defaultPageResolver } from '@portal-core/auth/resolvers/default-page.resolver';
import { EmptyComponent } from '@portal-core/general/components/empty/empty.component';
import { AlertType } from '@portal-core/general/enums/alert-type.enum';
import { pageNotFoundGuard } from '@portal-output/app/services/page-not-found.guard';
import { licenseResolver } from '@portal-output/core/services/license.resolver';
import { returnUrlResolver } from '@portal-output/core/services/return-url.resolver';
import { siteGuard } from '@portal-output/core/services/site.guard';

export const routes: Routes = [
  /** This route is used when the subdomain is invalid. It is at the root because it does not require a valid subdomain. */
  {
    path: 'licenseNotFound',
    data: {
      type: AlertType.LicenseNotFound
    },
    loadComponent: () => import('../alert/components/alert-page/alert-page.component').then(m => m.AlertPageComponent),
  },
  /** The root route for the rest of the pages in the app. */
  {
    path: '',
    canActivate: [subdomainGuard],
    children: [
      {
        path: ':siteKey',
        canActivate: [siteGuard],
        resolve: {
          licenseId: licenseResolver,
          returnUrl: returnUrlResolver
        },
        children: [
          {
            path: 'alert',
            loadComponent: () => import('../alert/components/alert-page/alert-page.component').then(m => m.AlertPageComponent)
          },
          {
            path: 'confirm',
            children: [
              {
                path: 'sso',
                loadComponent: () => import('../confirm/sso/components/sso-page/sso-page.component').then(m => m.SsoPageComponent)
              },
              {
                path: 'sso-email',
                loadChildren: () => import('../confirm/new-sso-user/new-sso-user.routes').then(m => m.NEW_SSO_USER_ROUTES)
              },
              {
                path: '',
                loadChildren: () => import('../complete-invite/complete-invite.routes').then(m => m.COMPLETE_INVITE_ROUTES)
              }
            ]
          },
          {
            path: 'expired-password',
            loadComponent: () => import('../expired-password/components/expired-password-page/expired-password-page.component').then(m => m.ExpiredPasswordPageComponent)
          },
          {
            path: 'forgot-password',
            loadComponent: () => import('../forgot-password/components/forgot-password-page/forgot-password-page.component').then(m => m.ForgotPasswordPageComponent)
          },
          {
            path: 'login',
            loadComponent: () => import('../login/components/login-page/login-page.component').then(m => m.LoginPageComponent)
          },
          {
            path: 'logout',
            loadComponent: () => import('../logout/components/logout-page/logout-page.component').then(m => m.LogoutPageComponent)
          },
          {
            path: 'reset-password',
            loadChildren: () => import('../reset-password/reset-password.routes').then(m => m.RESET_PASSWORD_ROUTES)
          },
          {
            path: '',
            canActivate: [authUserDataGuard],
            children: [
              {
                path: '',
                resolve: {
                  defaultPage: defaultPageResolver,
                },
                component: EmptyComponent
              },
              {
                path: '',
                canActivate: [authGuard],
                children: [
                  {
                    path: 'sites',
                    loadComponent: () => import('../sites/components/sites-page/sites-page.component').then(m => m.SitesPageComponent)
                  },
                  {
                    path: 'user-profile',
                    loadComponent: () => import('../user-profile/components/user-profile-page/user-profile-page.component').then(m => m.UserProfilePageComponent)
                  }
                ]
              }
            ]
          },
          {
            path: '**',
            canActivate: [pageNotFoundGuard],
            component: EmptyComponent
          }
        ]
      }
    ]
  },
  {
    path: '**',
    canActivate: [pageNotFoundGuard],
    component: EmptyComponent
  }
];
